import React, { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import { IonContent, IonLabel, IonList } from '@ionic/react';
import { AppContext } from '../../../global/AppContext';
import MatchmakingContext from '../../../global/MatchmakingContext';
import useMenu from '../../../global/useMenu';
import { AuthContext } from '../../authentication/AuthContext';
import ModalHeader from '../ModalHeader';
import SelectionCarousel from '../SelectionCarousel';
import { StartFightContext } from '../StartFightContext';
import useCanGo from '../useCanGo';
import MenuItemCard from './MenuItemCard';

import '../../../styles/fight/items/PickItems.scss';

function capitalize(str) {
  if (!str || typeof str !== 'string') return '';
  return str.replace(/\b\w/g, match => match.toUpperCase());
}

function PickItems({ pageIndex }) {
  const startFightCtx = useContext(StartFightContext);
  // eslint-disable-next-line no-unused-vars
  const appCtx = useContext(AppContext);
  // eslint-disable-next-line no-unused-vars
  const authCtx = useContext(AuthContext);
  const matchmakingCtx = useContext(MatchmakingContext);

  const hasItems = startFightCtx.items.length > 0;
  useCanGo(pageIndex, () => hasItems, [hasItems]);

  const [activeCategory, setActiveCategory] = useState();
  // eslint-disable-next-line no-unused-vars
  const [reload, menu, categories, menuSource] = useMenu();
  const [observer, setObserver] = useState();

  const [rematchItems, setRematchItems] = useState([]);
  useEffect(() => {
    if (matchmakingCtx.state.items?.length > 0 && menu.length > 0) {
      const matchedItems = matchmakingCtx.state.items.map(item => {
        const matched = menu.find(m => m.name.toLowerCase() === item.name.toLowerCase());
        if (!matched) {
          console.warn(`Could not find menu item for "${item.name}"`);
          return null;
        }
        return {
          id: matched.id,
          name: matched.name,
          price: matched.price,
          amount: item.amount,
        };
      });
      setRematchItems(matchedItems);
    }
  }, [matchmakingCtx.state.items, menu]);

  const sortedCategories = useMemo(() => {
    if (!menu?.categories) return categories;

    const categoryRanks = new Map();
    menu.categories.forEach((category, index) => {
      categoryRanks.set(category.name, index + 1);
    });
    return [...categories].sort((a, b) => {
      const rankA = categoryRanks.get(a) ?? Number.MAX_SAFE_INTEGER;
      const rankB = categoryRanks.get(b) ?? Number.MAX_SAFE_INTEGER;
      return rankA - rankB;
    });
  }, [menu, categories]);

  const categoryRefs = useCallback(
    node => {
      if (node !== null) {
        if (!categoryRefs.current) {
          categoryRefs.current = [];
        }

        categoryRefs.current.push(node);
        observer?.observe(node);
      }
    },
    [observer],
  );

  useEffect(() => {
    if (!observer) {
      setObserver(
        new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              const newCategory = Number.parseInt(entry.target.getAttribute('category'), 10);
              setActiveCategory(newCategory);
              // swiperRef.current.swiper.slideTo(newCategory, 500, false);
            }
          },
          {
            root: document.querySelector('#menu-list'),
            rootMargin: '0px 0px -90% 0px', // Adjusts the "trigger zone"
            threshold: 0,
          },
        ),
      );
    }

    // clean up observer
    return () => observer?.disconnect();
  }, [observer]);

  // const isMenuLoaded =
  //   Array.isArray(categories) &&
  //   categories.length > 0 &&
  //   (menuSource === 'mealme' ? menu && menu.categories : Array.isArray(menu));

  return (
    <>
      <ModalHeader pageName='Pick Items' />
      <IonContent id='pick-items-modal-page' rerender={menu} scrollY={false}>
        <SelectionCarousel
          carouselItems={sortedCategories.map(category => capitalize(category))}
          selectedIndex={activeCategory}
          onSelect={index => {
            setActiveCategory(index);
            categoryRefs.current[index].scrollIntoView(true);
          }}
        />
        <IonList id='menu-list'>
          {sortedCategories?.length > 0 &&
            sortedCategories
              .map(category => menu.filter(item => item.category === category))
              .map((items, index) => {
                // TODO: when an item is removed from the foodfight summary the changes are not reflected here
                return (
                  <div
                    className='menu-section'
                    ref={categoryRefs}
                    // XXX: can change later if needed
                    // eslint-disable-next-line react/no-unknown-property
                    category={index}
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    style={items.length === 0 ? { display: 'none' } : undefined}>
                    <IonLabel className={`label-title ${activeCategory === index ? 'active' : ''}`}>
                      {capitalize(sortedCategories[index])}
                    </IonLabel>
                    {items.map((item, i) => (
                      // <ItemCard
                      //   item={{
                      //     id: item.id,
                      //     name: item.name,
                      //     price: item.price,
                      //     amount: startFightCtx.items.find(fightItem => fightItem.id === item.id)?.amount || 0,
                      //   }}
                      //   // eslint-disable-next-line react/no-array-index-key
                      //   key={i}
                      // />
                      <MenuItemCard
                        item={{
                          id: item.id,
                          name: item.name,
                          price: item.price,
                          amount: startFightCtx.items.find(fightItem => fightItem.id === item.id)?.amount || 0,
                        }}
                        isEditable
                        // eslint-disable-next-line react/no-array-index-key
                        key={i}
                        rematchItem={rematchItems.find(matchItem => matchItem.name === item.name) || null}
                      />
                    ))}
                  </div>
                );
              })}
        </IonList>
      </IonContent>
    </>
  );
}

export default PickItems;
